// libs
import React, { memo, useEffect, useRef } from "react";
import styled from "@emotion/styled";

// constants
import { FONTS } from "shared/styles/base";

const BaseInput = styled.input<{ hasError?: boolean }>`
    width: 100%;
    font-family: ${FONTS.CERA};
    font-size: 1rem;
    text-align: left;
    height: 50px;
    padding: 0 10px;
    background-color: #fff;
    margin: 5px 0 0;
    border: 1px solid #ccc;
    border-radius: 2px;
    display: flex;
    align-items: center;
    outline: none;

    ${props => props.hasError && `border-color: #ff0000;`}
`;

interface IInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    hasError?: boolean;
}

function Input({ autoFocus, ...rest }: IInputProps) {
    const elRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (autoFocus && elRef.current !== null) {
            elRef.current.focus();
        }
    }, [autoFocus]);

    return <BaseInput ref={elRef} {...rest} />;
}

export default memo(Input);
